import { Column } from "../components/common/Table/Interfaces";
import { IObjectMap } from "../interfaces/common";

function getValue<DataType>(
  column: Column<DataType>,
  value: string | string[]
): string[] {
  if (column.filterMultiple) {
    return value as string[];
  }
  return [value as string];
}

const updateSortingAndFiltersOfColumns = <DataType>(
  columns: Column<DataType>[],
  parameters: IObjectMap
): Column<DataType>[] => {
  const filters = parameters.grouping as IObjectMap | undefined;
  const sortColumn = parameters.sortColumn as string | undefined;
  const sortDirection = parameters.sortDirection as
    | "descend"
    | "ascend"
    | undefined;

  if (!filters && !sortColumn) {
    return columns;
  }

  let copy = [...columns];

  if (filters && Object.keys(filters).length) {
    copy = copy.map((column) => {
      const value = filters[column.dataIndex] as string;

      return {
        ...column,
        filteredValue: value ? getValue(column, value) : null,
      };
    });
  }

  if (sortColumn) {
    copy = copy.map((column) =>
      column.dataIndex === sortColumn
        ? {
            ...column,
            sortOrder: sortDirection,
          }
        : column
    );
  }

  return copy;
};

export default updateSortingAndFiltersOfColumns;
